import { DEVICE_STATUS_TESTED } from 'xm-constants/device';

export const SET_DEVICE_TESTING_DISABLED = 'SET_DEVICE_TESTING_DISABLED';
export const DEVICE_TESTING_ADD_DEVICE = 'DEVICE_TESTING_ADD_DEVICE';
export const DEVICE_TESTING_CLEAR_PENDING = 'DEVICE_TESTING_CLEAR_PENDING';

export const MARK_DEVICE_AS_TESTED = 'MARK_DEVICE_AS_TESTED';
export const MARK_DEVICE_AS_TESTED_START = `${MARK_DEVICE_AS_TESTED}_START`;
export const MARK_DEVICE_AS_TESTED_SUCCESS = `${MARK_DEVICE_AS_TESTED}_SUCCESS`;
export const MARK_DEVICE_AS_TESTED_FAIL = `${MARK_DEVICE_AS_TESTED}_FAIL`;

export const SEND_TEST_MESSAGE = 'SEND_TEST_MESSAGE';
export const SEND_TEST_MESSAGE_START = `${SEND_TEST_MESSAGE}_START`;
export const SEND_TEST_MESSAGE_SUCCESS = `${SEND_TEST_MESSAGE}_SUCCESS`;
export const SEND_TEST_MESSAGE_FAIL = `${SEND_TEST_MESSAGE}_FAIL`;

export const IS_DEVICE_TESTED = 'IS_DEVICE_TESTED';
export const IS_DEVICE_TESTED_START = `${IS_DEVICE_TESTED}_START`;
export const IS_DEVICE_TESTED_SUCCESS = `${IS_DEVICE_TESTED}_SUCCESS`;
export const IS_DEVICE_TESTED_FAIL = `${IS_DEVICE_TESTED}_FAIL`;

export function setDeviceTestingEnabled(enabled) {
  return { type: SET_DEVICE_TESTING_DISABLED, payload: enabled };
}

export function addDevice(device) {
  return { type: DEVICE_TESTING_ADD_DEVICE, payload: device };
}

export function clearPending(deviceId, tested) {
  return { type: DEVICE_TESTING_CLEAR_PENDING, payload: { deviceId, tested } };
}

export function markAsTested(params) {
  return {
    type: MARK_DEVICE_AS_TESTED,
    meta: {
      xmApi: true,
      uri: `/webapi/xm/1/devices`,
      method: 'post',
      params: { ...params, testStatus: DEVICE_STATUS_TESTED },
    },
    payload: params.id,
  };
}

export function sendTestMessage(deviceId) {
  return {
    type: SEND_TEST_MESSAGE,
    meta: {
      xmApi: true,
      uri: `/webapi/xm/1/device-tests`,
      method: 'post',
      params: {
        device: {
          id: deviceId,
          recipientType: 'DEVICE',
        },
      },
    },
    payload: deviceId,
  };
}

export function isDeviceTested({ ownerId }) {
  return {
    type: IS_DEVICE_TESTED,
    meta: {
      xmApi: true,
      uri: `/webapi/xm/1/people/${ownerId}/devices`,
      method: 'get',
    },
  };
}
